export const onBundleProductFragment = /* GraphQL */ `
    ... on BundleProduct {
    dynamic_sku
    dynamic_price
    dynamic_weight
    price_view
    ship_bundle_items
    items {
        title
        sku
        type
        required
        position
        options {
            uid
            label
            quantity
            can_change_quantity
            price
            price_type
            is_default
            position
            product {
                id
                name
                sku
                stock_status
                image {
                    url
                    label
                }
                price_range {
                    __typename
                    minimum_price {
                        __typename
                        regular_price {
                            __typename
                            value
                            currency
                        }
                        final_price {
                            __typename
                            value
                            currency
                        }
                        discount {
                            __typename
                            amount_off
                        }
                    }
                    maximum_price {
                        __typename
                        final_price {
                            __typename
                            value
                            currency
                        }
                        regular_price {
                            __typename
                            value
                            currency
                        }
                    }
                }
                __typename
            }
        }
    }
}
`
